var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMediaMiscClosedCaptioning = function SvgIconMediaMiscClosedCaptioning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.373 10.375a1.625 1.625 0 1 0 .76 3.063 1 1 0 0 1 .922 1.774c-.518.27-1.093.411-1.677.413h-.003a3.625 3.625 0 1 1 0-7.25h.003a3.66 3.66 0 0 1 1.677.413 1 1 0 1 1-.922 1.774 1.66 1.66 0 0 0-.76-.187M14.976 10.851a1.625 1.625 0 0 1 1.907-.289 1 1 0 0 0 .922-1.774 3.66 3.66 0 0 0-1.677-.413h-.003a3.625 3.625 0 0 0 0 7.25h.003a3.66 3.66 0 0 0 1.677-.413 1 1 0 1 0-.922-1.774 1.625 1.625 0 0 1-1.907-2.587"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 5.25c0-.966.784-1.75 1.75-1.75h16.5c.966 0 1.75.784 1.75 1.75v13.5a1.75 1.75 0 0 1-1.75 1.75H3.75A1.75 1.75 0 0 1 2 18.75zm2 .25v13h16v-13z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconMediaMiscClosedCaptioning;